module.exports = __webpack_public_path__ + "static/secondMovementLastSnippet3-4a53f9c951e066aae0aa15c8aacdfe4a.mp3";